module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('div', {
    staticClass: "product-newbox"
  }, _vm._l((_vm.data.details), function(item, index) {
    return _c('div', {
      staticClass: "p-detail-new nomargin",
      class: {
        'expanded': !item.expanded,
        'page-image': _vm.pageTypeImage,
        'first': index === 0
      }
    }, [_c('div', {
      staticClass: "p-title-box"
    }, [_c('div', {
      staticClass: "title-box",
      on: {
        "click": _vm.toggleDetail
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (!item._spreadAll) ? _c('div', {
      staticClass: "arrow arrow-down"
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "content-box",
      style: ('display:' + (_vm.pageTypeImage || index === 0 || item.expanded ? 'block' : 'none'))
    }, _vm._l((item.modules), function(modules, index) {
      return _c('div', {
        staticClass: "p-detail-content"
      }, [(modules.type == 'TEXT') ? _c('div', {
        staticClass: "p-child-content"
      }, [_c('div', {
        staticClass: "p-child-tit",
        domProps: {
          "innerHTML": _vm._s(_vm.formatHtml(modules.title))
        }
      })]) : _vm._e(), _vm._v(" "), ((modules.type !== 'LINK') && modules.text) ? _c('div', {
        staticClass: "p-text",
        domProps: {
          "innerHTML": _vm._s(_vm.formatHtml(modules.text))
        }
      }) : _vm._e(), _vm._v(" "), (modules.image) ? _c('div', {
        class: {
          'p-img': true,
          'no-margin': _vm.noMargin(index, _vm.data.imageMargin, item.modules) //如果上一张图片没有描述，则清楚图片间间隔
        }
      }, [_c('beast-image', {
        attrs: {
          "src": modules.image.src,
          "width": modules.image.width,
          "height": modules.image.height
        }
      }), _vm._v(" "), (modules.desc && modules.desc != '') ? _c('p', {
        staticClass: "p-img-desc"
      }, [_vm._v(_vm._s(modules.desc || ''))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm._l((modules.table), function(table) {
        return (modules.type == 'TABLE') ? _c('div', {
          staticClass: "p-variant"
        }, [_c('div', {
          staticClass: "p-variant-name"
        }, [_vm._v(_vm._s(table.tableRow[0]))]), _vm._v(" "), _c('div', {
          staticClass: "p-variant-info",
          class: {
            'fixed-variant': _vm.pageTypeImage
          }
        }, [_c('p', {
          domProps: {
            "innerHTML": _vm._s(_vm.unescape(table.tableRow[1]))
          }
        })])]) : _vm._e()
      }), _vm._v(" "), _c('div', {
        staticClass: "p-brand-wrap"
      }, [(!_vm.pageTypeImage && modules.type == 'LINK') ? _c('div', {
        staticClass: "p-brand-index"
      }, [_c('a', {
        attrs: {
          "href": _vm._f("formatLink")(modules.link)
        }
      }, [_vm._v(_vm._s(modules.text))]), _vm._v(" "), _c('i')]) : _vm._e()])], 2)
    }), 0)])])
  }), 0) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b5cd260"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/components/desc-new.vue
// module id = 1036
// module chunks = 2